import {createStyles, Theme} from "@material-ui/core";
import {beigeColor, buttonContained, buttonOutlined, greyInput, secondaryColor, styleColors, typography} from "src/main.style";

export const HeaderStyle = (theme: Theme) => createStyles({
  widePaper : {
    flexGrow: 1,
  },
  renamePaper: {
    alignSelf: 'flex-start',
    marginTop: '64px',
  },
  fullscreenPaper : {
    alignSelf: 'flex-start',
    margin: '0px',
    width:'min(100vw,600px)',
    minWidth:'min(100vw,600px)',
    maxWidth:'min(100vw,600px)',
    height:'100vh',
    maxHeight:'100vh',
    minHeight:'100vh',
    overflow:'auto'
  },
  background: {
    boxSizing: 'content-box',
    position: 'fixed',
    overflow: 'hidden',
    top: 0,
    left: 0,
    width: '100vw',
    minWidth: '100vw',
    maxWidth: '100vw',
    height: '100vh',
    minHeight: '100vh',
    maxHeight: '100vh',
    // zIndex: 0,
    backgroundColor: theme.palette.background.default,
  },
  circle: {
      // zIndex: 1,
      position: 'absolute',
      top: '20rem',
      left: '-1.75rem',
      width: '56.25rem',
      height: '56.25rem',
      borderRadius: '56.25rem',
      backgroundColor: beigeColor,
  },
  header: {
    width: '100%',
    maxHeight: '65px',
    minHeight: '65px',
    height: '65px',
    backgroundColor: styleColors.greyLight2,
    position: 'fixed',
    top:0,
    display: 'flex',
    boxShadow: `0px 0px 10px ${styleColors.chromePurpleShadow}`,
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    transition : 'all 0.3s',
    zIndex:2,
  },

  headerTitle : {
    fontSize: '25px',
    fontWeight: 700,
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '50px',
    padding: '3px',
    position: 'fixed',
    top:0,
    pointerEvents: 'none',
    width: '100%',
    textAlign: 'center',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  },
  headerButtons : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // paddingLeft: '16px',
    width: '100%',
  },
  monthInfo : {
    width: '100%',
    justifyContent: 'space-around',
    display: 'flex',
    alignSelf: 'center',
    fontSize: '25px',
    fontWeight: 700,
    color: styleColors.greyDark3,
    lineHeight: '25px',
  },
  weekInitials : {
    width: '100%',
    justifyContent: 'space-around',
    display: 'flex',
    position:'absolute',
    bottom:0,
    maxHeight: '15px',
    minHeight: '15px',
    height: '15px',
    backgroundColor: styleColors.white,
    color: styleColors.greyDark1,
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: 400,
    borderTop: `1px solid ${styleColors.greyLight2}`,
    borderBottom: `0.5px solid ${styleColors.greyMedium1}`,
    boxSizing: 'border-box',
  },
  dayInitial : {
    width: 'calc(100% / 7)',
    textAlign: 'center',
  },
  buttonOutlined,
  buttonContained,
  greyInput,
  menuPaper: {
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[4],
  },
  menuList: {
    padding: theme.spacing(1, 0),
  },
  vacationsMenuPaper: {
    minWidth: '160px',
  },
  menuListItem: {
    ...typography.input,
  },
  menuItemTitle : {
    fontSize: '14px',
    fontWeight: 400,
    whiteSpace: 'normal',
    display:'flex',
    alignItems: 'center',
  },
  menuItemTime : {
    fontSize: '10px',
    fontWeight: 300,
    textWrap: 'wrap',
    maxWidth: '200px',
  },
  menuItemEnd : {
    opacity: 0.7,
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  menuItemBadge : {
    backgroundColor: styleColors.steelBlue,
    minWidth: '12px',
    height: '12px',
    fontSize: '10px',
    lineHeight: '12px',
    borderRadius: '10px',
    textAlign: 'center',
    position: 'absolute',
    /* left: 6px; */
    left: '38px',
  },
  suggestionBadge : {
    height: '18px',
    display: 'flex',
    fontSize: '12px',
    minWidth: '18px',
    maxWidth: '48px',
    placeContent: 'center',
    lineHeight: '18px',
    borderRadius: '20px',
    backgroundColor: styleColors.steelBlue,
    color: styleColors.white,
    transition: 'all 0.3s',
    marginLeft: '3px',
    alignSelf: 'center',
  }, 
  hiddenBadge : {
    scale: 0,
    maxWidth: 0,
    minWidth: 0,
  },
  textInputLine : {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    padding: '8px',
    fontSize: '16px',
  },
  snackBar : {
    boxShadow: `0px 3px 5px -1px ${styleColors.blackAlpha18}, 0px 6px 10px 0px ${styleColors.blackAlpha12}, 0px 1px 18px 0px ${styleColors.blackAlpha12}`,
    display: 'flex',
    padding: '6px 16px',
    fontSize: '0.875rem',
    lineHeight: '1.43',
    borderRadius: '4px',
    letterSpacing: '0.01071em',
    // Brand purple in both themes, so the text stays white in dark mode too.
    color: theme.palette.secondary.contrastText,
    fontWeight: 500,
    backgroundColor: secondaryColor,// styleColors.materialRed,
    position: 'absolute',
    right: '60px',
    zIndex: 1,
    alignItems: 'center',
    top: '3px',
    transition: 'all 0.3s',
    opacity:1,
    userSelect: 'none',
    WebkitUserSelect: 'none',
  },
  snackBarHidden : {
    boxShadow: `0px 3px 5px -1px ${styleColors.transparentBlack}`,
    display: 'flex',
    padding: '6px 16px',
    fontSize: '0.875rem',
    lineHeight: '1.43',
    borderRadius: '4px',
    letterSpacing: '0.01071em',
    // Brand purple in both themes, so the text stays white in dark mode too.
    color: theme.palette.secondary.contrastText,
    fontWeight: 500,
    backgroundColor: secondaryColor,// styleColors.materialRed,
    position: 'absolute',
    right: '60px',
    zIndex: 1,
    alignItems: 'center',
    top: '3px',
    transition: 'all 0.2s',
    opacity:0,
    pointerEvents:'none',
  },

  snackBarArrow : {
    position: 'absolute',
    top: '50%',
    right: '-5px', /* Adjust this value to position the triangle */
    width: 0,
    height: 0,
    borderTop: `5px solid ${styleColors.transparent}`, /* Adjust the size of the triangle */
    borderBottom: `5px solid ${styleColors.transparent}`, /* Adjust the size of the triangle */
    borderLeft: '5px solid '+secondaryColor, /* Adjust the color of the triangle */
    transform: 'translateY(-50%)', /* Center the triangle vertically */
  },
  snackBarIcon : {
    display: 'flex',
    opacity: 0.9,
    padding: '7px 0',
    fontSize: '22px',
    marginRight: '12px',
  },
  snackBarSentSuggestions : {
    position: 'fixed',
    zIndex: 1,
    width: '200px',
    right: '6px',
    display: 'flex',
    top: '48px',
  },
  snackBarWithImage : {
    flexWrap: 'wrap',
    paddingBottom: '12px',
  },
  snackBarImage : {
    display: 'block',
    width: '100%',
    marginTop: '4px',
    borderRadius: '4px',
  },
  closeBarIcon : {
    display: 'flex',
    opacity: 0.9,
    padding: '7px 0',
    fontSize: '22px',
    marginLeft: '12px',
  },
  helpModal : {
    backgroundColor:styleColors.transparentBlack,
  },
  imagePreview : {
    width: "50px",
    height: "50px",
    borderRadius: "10%",
    marginLeft: "auto",
    border: `1px solid ${styleColors.greyMedium1}`
  },
  activityLog : {
    display: "flex",
    whiteSpace: "normal",
    flexDirection: "column",
    fontSize: "14px",
    gap: "5px"
  }
});



// WEBPACK FOOTER //
// ./src/components/calendar2/header/Header.style.ts